import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
import { startAlerta } from "./ui/alertas";
///import { spinner, spinnerClose } from '../helpers/spinners';
import { startSpinner,finishSpinner } from "./ui/spinner";

export const centrosMedicosPropiosTraerStart = () => ({ type: types.centrosMedicosPropiosTraerStart });
export const centrosMedicosPropiosLimpiar = () => ({ type: types.centrosMedicosPropiosLimpiar });
export const centrosMedicosPropiosTraerError = (error) => ({ type: types.centrosMedicosPropiosTraerError,payload: error});
export const centrosMedicosPropiosTraerSuccess = (payload) => {
  return {
    type: types.centrosMedicosPropiosTraerSuccess,
    payload: payload
  }
}

export const fetchCentrosMedicosPropios = () => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(centrosMedicosPropiosTraerStart());
      const response = await fetchConToken(`CentrosMedicosPropios`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch( centrosMedicosPropiosTraerSuccess(lista) );
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchCentrosMedicosPropiosHabilitados = () => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(centrosMedicosPropiosTraerStart());
      const response = await fetchConToken(`CentrosMedicosPropios/traerHabilitados`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch( centrosMedicosPropiosTraerSuccess(lista) );
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchCentrosMedicosPropiosPorUsuario = () => {
  return async (dispatch) => {
    try{
      dispatch(startSpinner());
      dispatch(centrosMedicosPropiosTraerStart());
      const response = await fetchConToken(`CentrosMedicosPropios/traerPorUsuario`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch( centrosMedicosPropiosTraerSuccess(lista) );
      }
      dispatch(finishSpinner());
    } catch (err){
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};
